import { BindSwiperGalleryQuote, WireGalleryQuoteModal } from '../gallery-quote-modal';

main();

function main() {
    const bodyId = document.body.id;
    const minQty = ['coin', 'medal', 'buckle', 'ornament'].some(p => bodyId.includes(p)) ? 50 : 100;

    BindSwiperGalleryQuote(({ $body, $link, $img }) => {
        WireGalleryQuoteModal($body, {
            lineItem: 'Challenge Coins',
            minQty: minQty,
            formName: 'coins pricing page gallery',
            productLabel: 'Challenge Coins',
            notesIntro: 'something like this coin from your "Custom Challenge Coins" gallery',
            imageSrc: $img.src,
            reopen: () => $link.click(),
        });
    });
}
